// extracted by mini-css-extract-plugin
export default {"quantity":"styles_quantity__0dtid"};